module.exports = window["ssc-ui-vue/dist/ssc-ui-vue-new.css"];